import { render, staticRenderFns } from "./fleeing.vue?vue&type=template&id=8ef5c39c&scoped=true"
import script from "./fleeing.vue?vue&type=script&lang=js"
export * from "./fleeing.vue?vue&type=script&lang=js"
import style0 from "./fleeing.vue?vue&type=style&index=0&id=8ef5c39c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ef5c39c",
  null
  
)

export default component.exports